import React from "react";
import ProgressBar from "./Components/ProgressBar";
import DetailingHeatMap from "./Components/DetailingHeatMap";
import GrowPrescriberTable from "./Components/GrowPrescriberTable";
import CompanyAnnouncement from "./Components/CompanyAnnouncementCard";
import PrescriberLadder from "./Components/PrescriberLadder";


const Dashboard = () => {
  return (
    <>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", // Dynamic columns based on content
        gap: "16px",
        marginTop: 10,
        textAlign: "center",
        width: "100%",
        padding: 10,
      }}
    >
      {/* ProgressBar Components */}
      <ProgressBar
        total={5000}
        doctorCoverage={3500}
        vfCoverage={1500}
        doctorLabel="Doctor Coverage"
        vfLabel="VF Coverage"
        showTwoLines={true}
        title="Team Coverage Compliance"
      />

      <ProgressBar
        total={5000}
        doctorCoverage={3500}
        vfCoverage={1500}
        doctorLabel="Doctor Coverage"
        vfLabel="VF Coverage"
        showTwoLines={false}
        title="Team RCPA Compliance"
      />

      <ProgressBar
        total={5000}
        doctorCoverage={3500}
        vfCoverage={1500}
        doctorLabel="Doctor Coverage"
        vfLabel="VF Coverage"
        showTwoLines={false}
        title="Team RCPA Compliance"
      />

      <ProgressBar
        total={5000}
        doctorCoverage={3500}
        vfCoverage={1500}
        doctorLabel="Doctor Coverage"
        vfLabel="VF Coverage"
        showTwoLines={false}
        title="Team RCPA Compliance"
      />
    </div>
    <div  style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", // Dynamic columns based on content
        gap: "16px",
        marginTop: 10,
        textAlign: "center",
        width: "100%",
        padding: 10,
      }}>
    <PrescriberLadder/>
      <DetailingHeatMap/>
      </div>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", // Dynamic columns based on content
        gap: "16px",
        marginTop: 10,
        textAlign: "center",
        width: "100%",
        padding: 10,
      }}
    >
      <CompanyAnnouncement/>
      <GrowPrescriberTable/>
      </div>
      </>
  );
};

export default Dashboard;
